import {
  CANCELLED_TAB_ANALYTICS,
  CANCELLED_TAB_VALUE,
  FULLORDER_TAB_ANALYTICS,
  FULLORDER_TAB_VALUE,
  INPROGRESS_TAB_ANALYTICS,
  INPROGRESS_TAB_VALUE,
  LINE_ITEM_STATUS_RETURN_ACCEPTED,
  LINE_ITEM_STATUS_RETURN_CANCELLED,
  LINE_ITEM_STATUS_RETURN_REJECTED,
  LINE_ITEM_STATUS_RETURN_REQUESTED,
  RETURNED_TAB_ANALYTICS,
  RETURNED_TAB_VALUE,
  SHIPPED_TAB_ANALYTICS,
  SHIPPED_TAB_VALUE,
  SERVICES_SHIPPING_TYPE,
} from "@/components/OrderConfirmation/OrderDetailsTabs/constant"

export const getTmpType = ({ category, i18n }) => {
  const categoryType = category?.toLowerCase() ?? ""
  const { perBox = "", bucket = "", perEach = "" } = i18n ?? {}
  if (categoryType?.includes("tile") || categoryType?.includes("mosaics")) {
    return perBox?.toLowerCase()
  } else if (categoryType?.includes("grout")) {
    return `/${bucket?.toLowerCase()}`
  } else if (categoryType?.includes("trim")) {
    return `${perEach?.toLowerCase()}`
  } else {
    return ""
  }
}

export const getAllAdditinalInfo = e => {
  const {
    totalarea: totalArea = "",
    totaloverageval: overage = "",
    soldbyuom: soldByUom = "",
    soldbybox: soldByBox = "",
    templatetype: templateType = "",
    price = "",
    name = "",
    desc = "",
    image = "",
    currencysign: currencySign = "",
    totalneeded: totalNeeded = "",
    discountprice: discountPrice = "",
    totalprice: totalPrice = "",
    totalSFNeeded = "",
    totalUserNeeded = "",
    totalSFUserNeeded = "",
    totalboxes: totalBoxes = "",
  } = e?.target?.dataset ?? {}

  return {
    totalArea,
    overage,
    soldByUom,
    soldByBox,
    templateType,
    price,
    name,
    desc,
    image,
    currencySign,
    totalNeeded,
    discountPrice,
    totalPrice,
    totalSFNeeded,
    totalUserNeeded,
    totalSFUserNeeded,
    totalBoxes,
  }
}

export const getDiscountPrice = (
  discountPrice,
  discountUnitPrice,
  unitPrice
) => {
  if (discountPrice > 0) {
    return discountPrice
  } else if (discountUnitPrice > 0) {
    return discountUnitPrice
  } else {
    return unitPrice
  }
}
export const getReturnStatusDescription = (status = "", staticText = {}) => {
  const {
    returnRequestedDescription = "",
    returnAcceptedDescription = "",
    returnRejectedDescription = "",
    returnCancelledDescription = "",
  } = staticText
  switch (status) {
    case LINE_ITEM_STATUS_RETURN_REQUESTED:
      return returnRequestedDescription
    case LINE_ITEM_STATUS_RETURN_ACCEPTED:
      return returnAcceptedDescription
    case LINE_ITEM_STATUS_RETURN_REJECTED:
      return returnRejectedDescription
    case LINE_ITEM_STATUS_RETURN_CANCELLED:
      return returnCancelledDescription
    default:
      return ""
  }
}

export const checkReturnStatus = (status = "") => {
  const returnStatuses = [
    LINE_ITEM_STATUS_RETURN_REQUESTED,
    LINE_ITEM_STATUS_RETURN_ACCEPTED,
    LINE_ITEM_STATUS_RETURN_REJECTED,
    LINE_ITEM_STATUS_RETURN_CANCELLED,
  ]
  return returnStatuses.includes(status)
}

export const getFormattedTabNameForAnalytics = (tabName = "") => {
  const formattedTabNames = {
    [FULLORDER_TAB_VALUE]: FULLORDER_TAB_ANALYTICS,
    [SHIPPED_TAB_VALUE]: SHIPPED_TAB_ANALYTICS,
    [INPROGRESS_TAB_VALUE]: INPROGRESS_TAB_ANALYTICS,
    [RETURNED_TAB_VALUE]: RETURNED_TAB_ANALYTICS,
    [CANCELLED_TAB_VALUE]: CANCELLED_TAB_ANALYTICS,
  }
  return formattedTabNames[tabName]?.toLowerCase() || ""
}

export const servicesItem = category => {
  if (!category) return false
  const categoryType = category?.toUpperCase() ?? ""
  return SERVICES_SHIPPING_TYPE.includes(categoryType)
}
